<div class="pia-cardsBlock pia" [attr.data-id]="archivedPia.id">
  <div class="pia-cardsBlock-item pia-doingBlock-item">
    @if (attachments && attachments.length > 0) {
    <div class="pia-cardsBlock-item-attachment" aria-hidden="true">
      <span class="pia-icons pia-icon-attachment"></span>
      <ul>
        @for (attachment of attachments; track attachment) {
        <li>{{ attachment.name }}</li>
        }
      </ul>
    </div>
    }

    <div class="pia-cardsBlock-toolbar">
      @if ( !authService.state ||
      authService.currentUserValue.access_type.includes('technical') ||
      authService.currentUserValue.access_type.includes('functional') ) {
      <div class="pia-cardsBlock-toolbar-export">
        <a
          href="javascript:;"
          (click)="unarchive(archivedPia.id)"
          class="btn pia-tooltip"
        >
          <fa-icon [icon]="faRefresh"></fa-icon>
          <span
            title="{{ 'homepage.cards.item.tools.unarchive' | translate }}"
            class="pia-tooltip-text"
            >{{ "homepage.cards.item.tools.unarchive" | translate }}</span
          >
        </a>
        <a
          href="javascript:;"
          (click)="remove(archivedPia.id)"
          class="btn pia-tooltip"
        >
          <fa-icon [icon]="faTrash"></fa-icon>
          <span
            title="{{ 'homepage.cards.item.tools.remove' | translate }}"
            class="pia-tooltip-text"
            >{{ "homepage.cards.item.tools.remove" | translate }}</span
          >
        </a>
      </div>
      }
    </div>

    <form class="pia-cardsBlock-item-form" [formGroup]="piaForm">
      <input type="hidden" />
      <div style="margin-top:20px;">
        <label for="pia-edit-name">{{
          "homepage.cards.pia_name" | translate
        }}</label>
        <div class="archive">{{ archivedPia.name }}</div>
      </div>
      <div>
        <label for="pia-edit-author-name">{{
          "homepage.cards.author" | translate
        }}</label>
        @if (authService.state) {
        <tag-input
          [disable]="
            authService.currentUserValue &&
            !authService.currentUserValue.access_type.includes('functional')
          "
          [theme]="'foundation-theme'"
          [removable]="false"
          formControlName="author_name"
          [hideForm]="true"
        >
          <ng-template let-item="item" let-index="index">
            <div
              [ngClass]="{
                'custom-tag': true
              }"
            >
              {{ item.display }}
            </div>
          </ng-template>
        </tag-input>
        } @else {
        <div class="archive">{{ archivedPia.author_name }}</div>
        }
      </div>
      <div>
        <label for="pia-edit-evaluator-name">{{
          "homepage.cards.evaluation" | translate
        }}</label>
        @if (authService.state) {
        <tag-input
          [disable]="
            authService.currentUserValue &&
            !authService.currentUserValue.access_type.includes('functional')
          "
          [theme]="'foundation-theme'"
          [removable]="false"
          formControlName="evaluator_name"
          [hideForm]="true"
        >
          <ng-template let-item="item" let-index="index">
            <div
              [ngClass]="{
                'custom-tag': true
              }"
            >
              {{ item.display }}
            </div>
          </ng-template>
        </tag-input>
        } @else {
        <div class="archive">{{ archivedPia.evaluator_name }}</div>
        }
      </div>
      <div>
        <label for="pia-edit-validator-name">{{
          "homepage.cards.validation" | translate
        }}</label>
        @if (authService.state) {
        <tag-input
          [disable]="
            authService.currentUserValue &&
            !authService.currentUserValue.access_type.includes('functional')
          "
          [theme]="'foundation-theme'"
          [removable]="false"
          formControlName="validator_name"
          [hideForm]="true"
        >
          <ng-template let-item="item" let-index="index">
            <div
              [ngClass]="{
                'custom-tag': true
              }"
            >
              {{ item.display }}
            </div>
          </ng-template>
        </tag-input>
        } @else {
        <div class="archive">{{ archivedPia.validator_name }}</div>
        }
      </div>
      @if (authService.state) {
      <div>
        <label for="pia-edit-guest-name">{{
          "homepage.cards.guest" | translate
        }}</label>
        <div class="archive">{{ archivedPia.guests }}</div>
        <tag-input
          [disable]="
            authService.currentUserValue &&
            !authService.currentUserValue.access_type.includes('functional')
          "
          [theme]="'foundation-theme'"
          [removable]="false"
          [editable]="false"
          formControlName="guests"
          [hideForm]="true"
        >
          <ng-template let-item="item" let-index="index">
            <div
              [ngClass]="{
                'custom-tag': true
              }"
            >
              {{ item.display }}
            </div>
          </ng-template>
        </tag-input>
      </div>
      }
      <div>
        <label for="pia-edit-category">{{
          "homepage.cards.category" | translate
        }}</label>
        <div class="archive">{{ archivedPia.category }}</div>
      </div>
      @if (archivedPia.structure_id) {
      <div class="pia-cardsBlock-item-structure">
        <div>{{ "homepage.cards.structure" | translate }}</div>
        <span>{{ archivedPia.structure_name }}</span>
      </div>
      }
      <div class="pia-cardsBlock-item-date">
        <div>{{ "homepage.cards.date" | translate }}</div>
        <time>{{
          archivedPia.created_at
            | date: "shortDate":"":languagesService.selectedLanguage
        }}</time>
      </div>
      <div class="pia-cardsBlock-item-status">
        <div class="pia-cardsBlock-item-status-infos">
          <div>{{ "homepage.cards.status" | translate }}</div>
          @if ( archivedPia.status === 0 && archivedPia.progress === 100) {
          <div class="pendingValidation">
            {{ "pia.statuses.5" | translate }}
          </div>
          } @else {
          <div>
            {{ piaService.getStatusName(archivedPia.status) | translate }}
          </div>
          }
        </div>
        <div class="pia-cardsBlock-item-status-progressBar">
          <div>{{ archivedPia.progress }}%</div>
          <progress max="100" value="{{ archivedPia.progress }}"></progress>
        </div>
      </div>
      <div class="pia-cardsBlock-item-btn">
        <div class="pia-cardsBlock-item-btn-single">
          <a
            routerLink="/preview/{{ archivedPia.id }}"
            title="{{ 'homepage.cards.item.consult_pia' | translate }}"
            class="btn btn-green"
            >{{ "homepage.cards.item.consult_pia" | translate }}</a
          >
        </div>
      </div>
    </form>
  </div>
</div>
